import React, { useMemo } from 'react';
import { marked } from 'marked';

interface MarkdownFeedbackProps {
  content: string;
  className?: string;
}

/**
 * Composant pour afficher un feedback formaté en Markdown
 */
export const MarkdownFeedback: React.FC<MarkdownFeedbackProps> = ({ content, className = '' }) => {
  // Configuration de marked pour un rendu sécurisé (une seule fois)
  useMemo(() => {
    marked.setOptions({
      breaks: true, // Convertir les retours à la ligne en <br>
      gfm: true, // Support GitHub Flavored Markdown
    });
  }, []);

  // Convertir le markdown en HTML de manière sécurisée
  const htmlContent = useMemo(() => {
    if (!content || content.trim().length === 0) {
      return '';
    }
    try {
      return marked.parse(content) as string;
    } catch (error) {
      console.error('Erreur lors du parsing Markdown:', error);
      // En cas d'erreur, retourner le contenu brut échappé
      return content.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
  }, [content]);

  if (!htmlContent) {
    return null;
  }

  return (
    <div 
      className={`markdown-feedback ${className}`}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
      style={{
        lineHeight: '1.6',
      }}
    />
  );
};

